<template>
  <span
    ><span class="mt-2 badge badge-primary" v-if="crediting_status == 'credited'">{{ crediting_status | t }}</span
    ><span class="mt-2 badge badge-warning" v-if="crediting_status == 'partly_credited'"
      >{{ crediting_status | t }} {{ invoice.credited_amount }} {{ invoice.currency }}</span
    ></span
  >
</template>
<script>
export default {
  props: ['invoice'],
  computed: {
    crediting_status() {
      if (!this.invoice) {
        return '';
      }

      return this.invoice.crediting_status;
    }
  }
};
</script>
